import ENGLISH_FLAG from './flags/gb.png'
import GREEK_FLAG from './flags/gr.png'
import IMAGE_NOT_FOUND from './imageNotFound.jpg'
import LOGO from './logo/logo.png'
import PROMO from './logo/logo.png'
import coffee1 from './aboutUs/coffeeMachine.jpg'
import coffee2 from './aboutUs/barista.jpg'
import chiller from './products/img.png'
import chiller2 from './products/img_1.png'
import product1 from './products/img_2.png'
import product2 from './products/img_3.png'
import dinersSmall from './bankSmalls/dinersSmall.png'
import dinersLittle from './bankSmalls/dinersLittle.png'
import visaSmall from './bankSmalls/visaSmall.png'
import visaLittle from './bankSmalls/visaLittle.png'
import mastercardSmall from './bankSmalls/mastercardSmall.png'
import mastercardLittle from './bankSmalls/mastercardLittle.png'
import master1 from './bankSmalls/master1.png'
import masterLittle from './bankSmalls/master1.png'
import iris from './bankSmalls/iris.png'
import product3 from './products/img_4.png'
import articleImage from './Article Image.png'
import headerCoffee from './HeaderCoffee.png'
import discountImage from './discount_7623531.png'
import bannerNew1 from './new_pics/banner1.jpg'
import bannerNew2 from './new_pics/banner2.jpg'
import bannerThree from './new_pics/banner3.jpg'
import filtra from './new_pics/filtra.jpg'
import weighCof from './new_pics/weighCof.png'
import coffee22 from './new_pics/coffee2.jpg'
import coffeeNew from './new_pics/coffee.jpg'


const Images = {
	logo: LOGO,
	imageNotFound: IMAGE_NOT_FOUND,
	englishFlag: ENGLISH_FLAG,
	greekFlag: GREEK_FLAG,
	promo: PROMO,
	coffee1:coffee1,
	coffee2:coffee2,
	chiller:chiller,
	chiller2:chiller2,
	product1:product1,
	product2:product2,
	product3:product3,
	dinersSmall:dinersSmall,
	dinersLittle:dinersLittle,
	visaSmall:visaSmall,
	visaLittle:visaLittle,
	mastercardSmall:mastercardSmall,
	mastercardLittle:mastercardLittle,
	master1:master1,
	masterLittle:masterLittle,
	iris:iris,
	articleImage:articleImage,
	headerCoffee:headerCoffee,
	discountImage:discountImage,
	bannerNew1:bannerNew1,
	bannerNew2:bannerNew2,
	bannerThree:bannerThree,
	filtra:filtra,
	weighCof:weighCof,
	coffee22:coffee22,
	coffeeNew:coffeeNew,
}

export default Images